import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { BottomSheet, BottomSheetProps } from '@shared/ui/molecules';
import ModalContent from './ModalContent';
type NewAccountsIntructionModalMobileProps = BottomSheetProps;
const NewAccountsIntructionModalMobile: FC<NewAccountsIntructionModalMobileProps> = ({
  open,
  onClose,
  ...rest
}) => <BottomSheet open={open} onClose={onClose} {...rest}>
    <ContentWrapper>
      <ModalContent onClose={onClose} />
    </ContentWrapper>
  </BottomSheet>;
export default NewAccountsIntructionModalMobile;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "cj5ox0u",
  propsAsIs: false,
  vars: {
    "cj5ox0u-0": [_exp()]
  }
}));

require("./NewAccountsIntructionModalMobile.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./NewAccountsIntructionModalMobile.tsx");